import { Button, ButtonProps, styled } from "@mui/material";
import React from "react";

export const StyledBookingFlowButton = styled((props: ButtonProps) => (
  <Button {...props} />
))({
  fontSize: "0.8rem",
  padding: "0.75rem",
  textTransform: "none",
  height: "2.5rem",
});
